import React, {useEffect, useState} from "react";
import image10 from "../../../../assets/images/blog11-10.png";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image27 from "../../../../assets/images/blog11-27.png";
import image16 from "../../../../assets/images/blog11-16.png";
import image9 from "../../../../assets/images/blog11-9.png";
import image26 from "../../../../assets/images/blog11-26.png";
import image8 from "../../../../assets/images/blog11-8.png";
import image24 from "../../../../assets/images/blog11-24.png";
import image20 from "../../../../assets/images/blog11-20.png";

import blogImg1 from "../../../../assets/images/blogImg12-1.png";
import blogImg2 from "../../../../assets/images/blogImg12-2.png";
import blogImg3 from "../../../../assets/images/blogImg12-3.png";
import blogImg4 from "../../../../assets/images/blogImg12-4.png";
import blogImg5 from "../../../../assets/images/blogImg12-5.png";
import blogImg6 from "../../../../assets/images/blogImg12-6.png";
import blogImg7 from "../../../../assets/images/blogImg12-7.png";
import blogImg8 from "../../../../assets/images/blogImg12-8.png";
import blogImg9 from "../../../../assets/images/blogImg12-9.png";
import blogImg10 from "../../../../assets/images/blogImg12-10.png";
import blogImg11 from "../../../../assets/images/blogImg12-11.png";
import blogImg12 from "../../../../assets/images/blogImg12-12.png";
import blogImg13 from "../../../../assets/images/blogImg12-13.png";
import blogImg14 from "../../../../assets/images/blogImg12-14.png";

const Blog12 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook: 31st March, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "30px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Tariffs, Tapering & Turning Points – Welcome to Q2 Chaos
        </p>
        <div className="subHeader">
          <p className="">Macro trends, trade setups, and sentiment shifts for the week of March 31st, 2025</p>
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">A Volatile Quarter-End as Markets Brace for Q2 Storms</p>
              <p>
                Last week closed on a heavy note—SPX finished at the lows, gold surged into ATH territory, consumer sentiment collapsed, and geopolitical tensions flared. It’s been a risk-off
                cocktail, and markets are entering April looking fragile.
              </p>
              <p>
                We’ve got a loaded calendar: Liberation Day on Wednesday, a high-stakes NFP Friday, and ongoing tariff noise out of Washington. With economic data pointing to contraction and
                policy-makers cornered between inflation and stagnation, the Q2 kick-off could turn into a volatility minefield.
              </p>
              <p>
                So what’s the playbook? We break down the macro narrative, sentiment signals, technical triggers, and trade setups to position into this week’s chaos—with charts to back every major
                theme.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <p className="highlightedBoldText">Key Market Themes: Cracks in the Foundation</p>
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">1. Sentiment Collapse: Consumers Wave the White Flag</p>
                <p>
                  The Conference Board’s Consumer Confidence Index cratered to <span className="highlightedText">92.9, </span>
                  driven by a chilling <span className="highlightedText">Expectations Index print of 65.2</span>--a level not seen since 2013 (ex-Covid). Historically, anything under 80 screams
                  recession ahead.{" "}
                </p>
                <p>
                  Older consumers are driving the collapse, with 55+ year-olds losing faith fast. Confidence among households earning under $125k tanked, and even high-income groups are starting to
                  flinch.
                </p>
              </div>
            </div>
          </div>
          <div className="imageWrapper">
            <div className="relatedImg">
              <img
                src={blogImg1}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(blogImg1)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <div className="relatedImg">
              <img
                src={blogImg2}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(blogImg2)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="subHeader">
            <div className="contentDivWrapper ">
              <div className="contentDiv">
                <p className="highlightedText_header">2. GDPNow Turns Negative—Gold Becomes the Truth Teller</p>
                <p>
                  The <span className="highlightedText">Atlanta Fed GDPNow model has sunk to -2.8%</span>, and the new "ex-gold" version sits at -0.5%. That’s a flashing red light for a{" "}
                  <span className="highlightedText">Q1 recession print</span>, especially since the Fed doesn't factor gold flows into GDP but GDPNow does.
                </p>
                <p>
                  The implications? Gold is distorting GDP metrics because it’s being bought as a monetary hedge—not for jewelry or industrial use. That tells us everything we need to know about
                  capital flows right now.
                </p>
              </div>
            </div>
          </div>

          <div className="imageWrapper">
            <div className="relatedImg">
              <img
                src={blogImg3}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(blogImg3)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <div className="relatedImg">
              <img
                src={blogImg4}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(blogImg4)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">3. Gold Surges: New ATHs as the Dollar Gets Dumped</p>
                <p>
                  The anti-dollar bid is alive. <span className="highlightedText">Gold hit new all-time highs</span>, acting as the safe haven of choice in this dollar and bond selloff. This isn’t
                  just an inflation hedge—it’s a global reserve diversification trade.
                </p>
                <p>
                  Gold is increasingly behaving like a <span className="highlightedText">macro hedge of last resort</span>—especially with central banks globally seen cutting or hesitating. With the
                  Fed boxed in by sticky inflation and a weakening economy, the move into tangible stores of value is accelerating.
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={blogImg5}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg5)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="subHeader">
            <div className="contentDivWrapper ">
              <div className="contentDiv">
                <p className="highlightedText_header">4. Tariff Risk Returns: 1930s Parallels Are No Longer Abstract</p>
                <p>
                  Trump’s trade aggression is escalating. Tariffs on Venezuela, auto components, and whispers of broader protectionist steps are sparking comparisons to{" "}
                  <span className="highlightedText">Smoot-Hawley</span>. This week marks the beginning of “Tariff Week” — don’t underestimate its market-moving power.
                </p>
                <p>
                  Behind the headlines, the message is clear: "Make America Build Again" is the new MAGA. The market sees this as a <span className="highlightedText">self-inflicted demand shock</span>
                  , layered over global stagflation concerns
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={blogImg6}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg6)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">5. DXY Breaking Down, FX Havens in Play</p>
                <p>
                  The <span className="highlightedText">US Dollar Index (DXY)</span> is firmly in a downtrend. Capital is fleeing USD and USTs simultaneously—a rare and dangerous macro signal.
                  Meanwhile, <span className="highlightedText">JPY and CHF</span> are emerging as favored FX hedges. Japan’s reduced bond QE is adding fire to the JPY story.
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={blogImg7}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg7)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <p className="highlightedBoldText">Technical & Sentiment Analysis: Bearish Bias with Event-Driven Whiplash Risk</p>

          <div className="subHeader">
            <div className="contentDivWrapper ">
              <div className="contentDiv">
                <p className="highlightedText_header">S&P 500: At the Ledge of Something Bigger?</p>
                <p>
                  The <span className="highlightedText">SPX closed the week at the lows</span>, with both spot and futures testing key support. Technically, this could be the final leg of a corrective
                  ABC pattern—or the start of a <span className="highlightedText">higher-degree wave 3 down</span>, which would be brutal.
                </p>
                <p>
                  Add in the massive <span className="highlightedText">Put interest still on the board</span>, and the risk/reward tilts toward a shortable bounce. Markets are sniffing out a liquidity
                  trap into quarter-end rebalancing—watch 5700–5725 as fade zones. The new LL for the chart suggests more downside
                </p>
              </div>
            </div>
            <div className="imageWrapper">
              <div className="relatedImg">
                <img
                  src={blogImg8}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg8)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={blogImg9}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg9)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="subHeader">
            <div className="contentDivWrapper">
              <div className="contentDiv">
                <p className="highlightedText_header">VIX and Vol Positioning: Straddles Are Back</p>
                <p>
                  The <span className="highlightedText">VIX dipped temporarily</span>, but April positioning still suggests fear. There's heavy demand for{" "}
                  <span className="highlightedText">volatility straddles</span>—trades that benefit from large moves either direction. That’s a red flag for stability.
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={blogImg10}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg10)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv">
                <p className="highlightedText_header">Bitcoin Losing Safe Haven Status</p>
                <p>BTC has rolled over. It’s now trading like a high-beta tech proxy—not a store of value. Gold has decisively stolen its hedge crown, while BTC HODLers are starting to shake.</p>
              </div>
              <div className="relatedImg">
                <img
                  src={blogImg11}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg11)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="subHeader">
            <div className="contentDivWrapper">
              <div className="contentDiv">
                <p className="highlightedText_header">Defensive & Stagflation Plays Still Leading</p>
                <p>
                  Sectors like Pharma, Utilities, and Consumer Staples are still outperforming. But with earnings season looming, there’s a risk these “safe” names get revalued lower if Q2 guidance
                  starts to slip.
                </p>
              </div>
              <div className="relatedImg">
                <img
                  src={blogImg12}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg12)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        {/*  */}
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Last Week’s Recap: PMI Pop, Retail Drops, and Earnings Misses</p>

                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Monday brought the strongest SPX gain since 2022</span>, but it faded fast
                    </p>
                  </li>
                  <li className="themesPointer listImage">
                    <p>
                      <span className="highlightedText">Global PMIs were mixed: </span>Aussie and Indian prints were solid, but Eurozone manufacturing remains weak..
                    </p>
                    <div className="relatedImg">
                      <img
                        src={blogImg13}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(blogImg13)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Earnings roll call: </span>KB Home, McCormick, and Kingfisher all missed or guided lower—signaling macro pressures are reaching Main Street.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Tariff Messaging </span>from Trump was chaos by design. Add in Venezuela oil drama and whispers of 25% EU auto tariffs, and the week ended on a
                      note of deep uncertainty.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />
        <p className="highlightedText_header">Upcoming Week Ahead: Big Landmines and Market Inflection Points</p>

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage_two">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Key Events to Watch</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Monday, Mar 31: </span>Month-end flows. Watch for <span className="highlightedText">Q-end window dressing</span> to create a rally that could be
                      sold into.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Tuesday, Apr 1: </span>
                      <span className="highlightedText">ISM Manufacturing, JOLTS</span>, and the <span className="highlightedText">RBA Rate Decision</span>. FX markets should move.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Wednesday, Apr 2 – Liberation Day + ADP Jobs + Factory Orders.</span> Thin liquidity and event risk.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Thursday, Apr 3 – Challenger layoffs + ISM Services + Jobless Claims.</span> Real economy flashpoints.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Friday, Apr 4 – NFP Friday – </span> all eyes on the print. A sub-100k jobs number could trigger panic.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="relatedImg">
                <img
                  src={blogImg14}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(blogImg14)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap listWithImage">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Actionable Takeaways: Q2 Begins With Fragile Footing</p>

                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText"> Any April bounce is a sell: </span>Rebalancing flows could lift markets temporarily. Fade strength into 5700–5725 and a likely 200dma re-test.
                      Downside Tests focus on Fib extensions between 5150 and 5400.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Long Gold looks a one-way bet but a break of 3050 may see a bigger sell off: </span>The Long term chart is near an end of a series of 5th waves
                      but fundamentally it's a buy. Pullbacks should be shallow but beware the channel breaking the downside. New ATHs could come quickly on Tariff fallout or if NFP disappoints.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">FX positioning matters—long JPY and CHF as defensive hedges: </span> Dollar is under siege. USDJPY may have started a new downleg and Yen buy.
                      151 is a resistance line but targeting a new low below 146.5; CHF is a classic risk off but beware the SNB response who are willing to intervene
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Play volatility—straddles or long vol setups: </span> With NFP, tariffs, and fragile sentiment, big swings are likely. VIX options or short-term
                      gamma plays are attractive.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />
        <span className="highlightedText">Final Verdict:</span>
        <p>
          Q1 ended with more questions than answers. Is this a healthy correction, or the start of a macro unwind? One thing is clear—traders can’t rely on passive flows anymore. Price action is
          speaking loudly, and it’s saying: <span className="highlightedText">expect the unexpected</span>.
        </p>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1uDizYitm3pk3wUkCWjhm8iKKJVYwvvH4AMjjnq5U2x4/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog12;
